import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import PeopleIcon from "@mui/icons-material/People";
import SearchIcon from "@mui/icons-material/Search";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import StoreIcon from "@mui/icons-material/Store";
import EditIcon from "@mui/icons-material/Edit";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ListAlt as ListAltIcon } from '@mui/icons-material';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import axios from "axios";
import { useEffect, useState } from "react";
import { FaBullhorn } from "react-icons/fa";
import { FiBell, FiMenu } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { io } from "socket.io-client";

const ManagerHeader = (props) => {
  const [managerName, setManagerName] = useState("");
  const [managerProfilePic, setManagerProfilePic] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Desktop dropdown
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  // Mobile complaint dropdown
  const [complaintDropdownOpen, setComplaintDropdownOpen] = useState(false);

  const navigate = useNavigate();

  const requestNotificationPermission = () => {
    if ("Notification" in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          console.log("Notification permission granted.");
        } else {
          console.log("Notification permission denied.");
        }
      });
    }
  };

  const showBrowserNotification = (title, options) => {
    if ("Notification" in window && Notification.permission === "granted") {
      new Notification(title, options);
    }
  };

  const handleNotificationClick = () => {
    navigate("/notify", { state: notifications });
  };

  const fetchManagerData = async () => {
    try {
      const managerID = localStorage.getItem("managerID");
      const token = localStorage.getItem("mangertoken");

      if (!token) {
        navigate("/ManagerLogin");
        return;
      }
      if (!managerID) {
        console.error("Manager ID not found in localStorage.");
        return;
      }

      const res = await axios.get(
        `https://server-side-influencer.onrender.com/manager/managers/${managerID}`
      );
      if (res.data && res.data.success && res.data.data.name) {
        setManagerName(res.data.data.name);
        setManagerProfilePic(
          res.data.data.profilePic || "https://via.placeholder.com/150"
        );
      }
    } catch (err) {
      console.error("Error fetching manager data:", err);
    }
  };

  useEffect(() => {
    fetchManagerData();
    requestNotificationPermission();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    const socket = io("https://server-side-influencer.onrender.com");

    socket.on("newMessage", (data) => {
      const { message, data: notificationData } = data;

      setNotifications((prev) => [
        ...prev,
        {
          message,
          shopName: notificationData.shopName,
          platform: notificationData.platform,
          budget: notificationData.budget,
        },
      ]);

      setUnreadCount((prev) => prev + 1);

      showBrowserNotification(message, {
        body: `Brand: ${notificationData.shopName}\nPlatform: ${notificationData.platform}\nBudget: ${notificationData.budget}`,
        icon: "https://via.placeholder.com/100",
      });
    });

    return () => {
      socket.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const menus = [
    { name: "Home", link: "/ManagerHome", icon: <HomeIcon /> },
    { name: "Brand campaigns", link: "/brandcampaigns", icon: <FaBullhorn /> },
    { name: "Influencers Requirements", link: "/request", icon: <PeopleIcon /> },
    { name: "Add Brand", link: "/AddNewBrand", icon: <StoreIcon /> },
    { name: "Add Influencer", link: "/AddNewInfluencer", icon: <PersonAddIcon /> },
    { name: "search", link: "/search1", icon: <SearchIcon /> },
    { name: "Plan and list", link: "/plan1", icon: <ListAltIcon /> },
    { name: "Bulk upload", link: "/upload", icon: <CloudUploadIcon /> },
    { name: "Profile", link: "/ManagerProfile", icon: <AccountCircleIcon /> },
  ];

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditProfile = () => {
    handleMenuClose();
    navigate("/updateagency");
  };

  const handleLogout = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      document.cookie.split(";").forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      window.open("https://smesh.in/", "_blank");
    } catch (err) {
      console.log("Error during logout:", err);
      window.open("https://smesh.in/", "_blank");
    }
  };

  return (
    <div>
      {/* Mobile Header */}
      {isMobile && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: "black",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
            zIndex: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png"
              alt="Influenceso Logo"
              style={{ width: "45px", height: "auto" }}
            />
            <span className="text-white font-semibold text-2xl mt-3">
              Influenceso
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              onClick={() => setMenuOpen(!menuOpen)}
              style={{ cursor: "pointer", fontSize: "28px", color: "#fff" }}
            >
              <FiMenu />
            </div>

            <div
              className="relative"
              onClick={handleNotificationClick}
              style={{ cursor: "pointer", fontSize: "28px", color: "#fff" }}
            >
              <FiBell />
              {unreadCount > 0 && (
                <span
                  className="absolute top-0 right-0 rounded-full bg-red-500 text-white text-xs sm:text-sm w-5 h-5 flex items-center justify-center"
                  style={{ marginTop: "-15px", marginLeft: "7px" }}
                >
                  {unreadCount}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Mobile Menu */}
      {menuOpen && isMobile && (
        <div
          style={{
            position: "absolute",
            top: "60px",
            left: 0,
            right: 0,
            backgroundColor: "black",
            padding: "15px",
            zIndex: 20,
          }}
        >
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {menus.map((menu, index) => (
              <li key={index} style={{ margin: "10px 0", color: "#fff" }}>
                <Link
                  to={menu.link}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                  onClick={() => setMenuOpen(false)}
                >
                  {menu.icon}
                  <span style={{ marginLeft: "10px" }}>{menu.name}</span>
                </Link>
              </li>
            ))}

            {/* Complaint Dropdown */}
            <li
              style={{
                margin: "10px 0",
                color: "#fff",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() =>
                setComplaintDropdownOpen((prev) => !prev)
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ display: "flex", alignItems: "center" }}>
                  <ListAltIcon style={{ marginRight: 8 }} />
                  Complaint
                </span>
                {complaintDropdownOpen ? (
                  <ArrowDropUpIcon />
                ) : (
                  <ArrowDropDownIcon />
                )}
              </div>

              {complaintDropdownOpen && (
                <ul
                  style={{
                    listStyle: "none",
                    paddingLeft: "20px",
                    marginTop: "8px",
                    color: "#ccc",
                  }}
                >
                  <li
                    style={{ margin: "6px 0" }}
                    onClick={() => setMenuOpen(false)}
                  >
                    <Link
                      to="/brandcomplaint"
                      style={{ color: "#ccc", textDecoration: "none" }}
                    >
                      <StoreIcon style={{ fontSize: 18 }} />
                      Brand
                    </Link>
                  </li>
                  <li
                    style={{ margin: "6px 0" }}
                    onClick={() => setMenuOpen(false)}
                  >
                    <PeopleIcon style={{ fontSize: 18 }} />
                    <Link
                      to="/allinfluencercomplaint"
                      style={{ color: "#ccc", textDecoration: "none" }}
                    >
                      Influencers
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Logout */}
            <li style={{ margin: "10px 0", color: "#fff" }}>
              <button
                onClick={() => {
                  localStorage.clear();
                  sessionStorage.clear();
                  navigate("/ManagerLogin");
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#fff",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <LogoutIcon style={{ color: "white" }} />
                <span style={{ marginLeft: "10px" }}>Logout</span>
              </button>
            </li>
          </ul>
        </div>
      )}

      {/* Desktop Header */}
      {!isMobile && (
        <div
          className="h-16 sm:h-20 flex items-center justify-between mx-2 sm:mx-4 w-full"
          style={{
            backgroundColor: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderBottom: "none",
            borderRadius: "12px",
          }}
        >
          <div className="flex items-center gap-2 ml-4">
            <img
              src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png"
              alt="Influenceso Logo"
              style={{ width: "45px", height: "auto" }}
            />
            <span className="text-black font-semibold text-2xl mt-3">
              Influenceso
            </span>
          </div>

          <div className="flex items-center space-x-4 mr-10">
            <div className="relative">
              <FiBell
                className="cursor-pointer"
                onClick={handleNotificationClick}
                style={{ fontSize: "24px" }}
              />
              {unreadCount > 0 && (
                <span
                  className="absolute top-0 right-0 rounded-full bg-red-500 text-white text-xs sm:text-sm w-5 h-5 flex items-center justify-center"
                  style={{ marginTop: "-15px", marginLeft: "7px" }}
                >
                  {unreadCount}
                </span>
              )}
            </div>

            <img
              className="w-10 h-10 rounded-full"
              src={managerProfilePic || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
              alt="Profile"
            />

            <div
              className="flex items-center space-x-1 font-medium cursor-pointer select-none"
              onClick={handleMenuClick}
            >
              <span>Hi, {managerName || "Manager"}</span>
              {isMenuOpen ? (
                <ArrowDropUpIcon fontSize="large" />
              ) : (
                <ArrowDropDownIcon fontSize="large" />
              )}
            </div>

            <Menu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={handleEditProfile}>
                <EditIcon fontSize="small" style={{ marginRight: 8 }} />
                Edit Profile
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon fontSize="small" style={{ marginRight: 8 }} />
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerHeader;
